import { FC,useState } from "react"

import Modal from "../modal";
import { StatisticsObjectType } from "./types";

const CustomButtonRight: FC<StatisticsObjectType> = ({ StatisticsObjectType }): JSX.Element => {
  const [showingModal, setModal] = useState(false);
  const [title, setTitle] = useState("");

  const openModal = (title: string) => {
    setTitle(title);
    setModal(true);
    document.body.style.overflow = 'hidden';
  };

  return (
    <>
        {showingModal ? <Modal title={title} data={title === "New Practices" ? StatisticsObjectType.new_practices.data : StatisticsObjectType.new_doctors ? StatisticsObjectType.new_doctors.data :  StatisticsObjectType.new_hcps.data} onClick={() => setModal(false)}></Modal> : null}
        <div className="card p-0 mb-3 flex-fill">
            <div className="card-header text-center">
              <h2 className="m-0 text-center text-primary">Pending Enrollments</h2>
            </div>
            <div className="card-body text-center">
              <h2 className="mt-2 mb-0 fw-bold" style={{fontSize: '2.5rem'}}>{StatisticsObjectType.pending_enrollments}</h2>
            </div>
        </div>
        <div className="card p-0 mb-3 flex-fill">
            <div className="card-header text-center">
              <h2 className="m-0 text-center text-primary">New Practices</h2>
            </div>
            <div className="card-body  text-center">
            <h2 className="fw-bold text-center" style={{fontSize: '2.5rem'}}>{StatisticsObjectType.new_practices.count}</h2>
            </div>
        </div>
        <div className="card p-0 flex-fill">
            <div className="card-header text-center">
              <h2 className="m-0 text-center text-primary">New HCPs</h2>
            </div>
            <div className="card-body text-center">
            <h2 className="fw-bold text-center" style={{fontSize: '2.5rem'}}> {StatisticsObjectType.new_doctors ? StatisticsObjectType.new_doctors.count :StatisticsObjectType.new_hcps.count }</h2>
          </div>
        </div>
    </>
  )
}
export default CustomButtonRight;
